import React, { useState } from 'react';
import { ArrowLeft } from 'lucide-react';

interface Props {
  onBack: () => void;
  onSave?: () => void;
}

export const ProjectInfoSettingsView: React.FC<Props> = ({ onBack, onSave }) => {
  const [managementType, setManagementType] = useState<'hired' | 'not_hired' | 'unspecified'>('hired');

  const handleSave = () => {
    if (onSave) onSave();
  };

  return (
    <div className="bg-white min-h-[480px] rounded-xl p-6 sm:p-8 font-prompt space-y-6 flex flex-col justify-between">
      <div className="space-y-8">
        {/* Top Header */}
        <div className="flex items-center gap-3 pb-2">
          <button
            type="button"
            onClick={onBack}
            className="w-8 h-8 rounded-full border border-slate-300 hover:border-slate-400 bg-white flex items-center justify-center text-slate-600 hover:text-slate-900 transition-colors cursor-pointer"
            title="ย้อนกลับ"
          >
            <ArrowLeft className="w-4 h-4" />
          </button>
          <h1 className="text-xl sm:text-2xl font-bold text-slate-800 tracking-tight">
            ตั้งค่าข้อมูลโครงการ
          </h1>
        </div>

        {/* Form Question */}
        <div className="max-w-2xl space-y-6 pt-2">
          <h2 className="text-base sm:text-lg font-bold text-slate-800">
            โครงการจ้างบริษัทบริหารมาช่วยดูแลนิติบุคคลให้ ใช่ หรือ ไม่?
          </h2>

          <div className="space-y-4 pt-1">
            <label className="flex items-center gap-3 cursor-pointer text-xs sm:text-sm text-slate-700">
              <input
                type="radio"
                name="managementType"
                value="hired"
                checked={managementType === 'hired'}
                onChange={() => setManagementType('hired')}
                className="w-4 h-4 text-blue-700 border-slate-300 focus:ring-blue-500 cursor-pointer"
              />
              <span>ใช่ - จ้างบริษัทบริหารนิติดูแล</span>
            </label>

            <label className="flex items-center gap-3 cursor-pointer text-xs sm:text-sm text-slate-700">
              <input
                type="radio"
                name="managementType"
                value="not_hired"
                checked={managementType === 'not_hired'}
                onChange={() => setManagementType('not_hired')}
                className="w-4 h-4 text-blue-700 border-slate-300 focus:ring-blue-500 cursor-pointer"
              />
              <span>ไม่ใช่ - ไม่ได้จ้าง</span>
            </label>

            <label className="flex items-center gap-3 cursor-pointer text-xs sm:text-sm text-slate-700">
              <input
                type="radio"
                name="managementType"
                value="unspecified"
                checked={managementType === 'unspecified'}
                onChange={() => setManagementType('unspecified')}
                className="w-4 h-4 text-blue-700 border-slate-300 focus:ring-blue-500 cursor-pointer"
              />
              <span>ไม่ระบุ</span>
            </label>
          </div>
        </div>
      </div>

      {/* Bottom Buttons */}
      <div className="flex justify-end items-center gap-3 pt-8">
        <button
          type="button"
          onClick={handleSave}
          className="px-6 py-2.5 bg-blue-700 hover:bg-blue-800 text-white rounded-lg text-sm font-semibold transition-colors shadow-xs cursor-pointer"
        >
          บันทึกเงื่อนไข
        </button>
        <button
          type="button"
          onClick={onBack}
          className="px-6 py-2.5 bg-slate-300 hover:bg-slate-400 text-slate-700 rounded-lg text-sm font-semibold transition-colors cursor-pointer"
        >
          ยกเลิก
        </button>
      </div>
    </div>
  );
};
